import { CssSelectors } from '@Styles/styles';
import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../components-v2/Theme/theme';

const { colors, common, typography } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[16],
		margin: '0 auto',
		maxWidth: 600,
		paddingTop: SPACE[32],
	},
	tabView: {
		width: '100%',
	},
	tabViewTabs: {
		display: 'flex',
		borderBottom: common.border,
	},
	tabViewItem: {
		color: colors.text.light,
		display: 'inline-flex',
		flexBasis: 'auto',
		fontSize: typography.fontSizes.sm,
		height: 44,
		paddingLeft: SPACE[32],
		paddingRight: SPACE[32],
		textAlign: 'center',
		textTransform: 'uppercase',
		whiteSpace: 'nowrap',
		gap: SPACE[8],
	},
	tabItemSelected: {
		borderBottom: `1px solid ${colors.primary.main}`,
	},
	section: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[16],
		alignItems: 'center',
		padding: SPACE[16],
	},
	logo: {
		...CssSelectors.allChildren({
			display: 'block',
			width: 350,
		}),
	},
	credentialField: {
		width: 300,
	},
	credentialInputRow: {
		display: 'flex',
	},
	credentialInput: {
		width: '100%',
	},
	connectForm: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[16],
		alignItems: 'center',
	},
});
